module.exports = __webpack_public_path__ + "img/module7.36dc2570.png";